import axios from "axios";
import { Markup } from "interweave";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import calendar from "../../../../../../../assets/images/meetupEvent/calendar.png";
import Clock from "../../../../../../../assets/images/meetupEvent/clock-icon.png";

import { Badge } from "react-bootstrap";
import AuctionDoneModal from "../AdminBidding/AuctionDoneModal";
import { serverInfo } from "../../../../../../../App";
import { useContext } from "react";
import { confirmAlert } from "react-confirm-alert";

const LiveBiddingsCheckout = () => {
  const { imageCdnUrl } = useContext(serverInfo);
  const params = useParams();
  //alert(auction_id)

  const [product, setProduct] = useState();
  const [topBidder, setTopBidders] = useState([]);
  const [topperId, setTopperId] = useState();

  const [modalShow, setModalShow] = React.useState(false);

  const openModal = (id) => {
    setModalShow(true);
    setTopperId(id);
  };

  const auctionDetails = () => {
    axios.get(`/api/admin/show/auction/product/${params.id}`).then((res) => {
      if (res.status === 200) {
        setProduct(res.data.product);
      }
    });
    axios.get(`/api/admin/topBidder/auction/${params.id}`).then((res) => {
      if (res.status === 200) {
        setTopBidders(res.data.topBidder);
      }
    });
  };

  useEffect(() => {
    auctionDetails();
  }, [params.id]);

  const handleRejection = (id) => {
    axios.post(`/api/admin/topBidder/auction/reject/${id}`).then((res) => {
      if (res.status === 200) {
        auctionDetails();
      }
    });
  };

  // Confirm Alert

  function makeConfirm(id) {
    confirmAlert({
      title: "Please Confirm Carefully",
      message: "If once submit, you can't undo !",
      buttons: [
        {
          label: "Yes",
          onClick: () => handleRejection(id),
        },
        {
          label: "No",
        },
      ],
    });
  }

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-6">
          <div className="card card-bg p-2">
            <img
              className="w-100 img-fluid"
              src={imageCdnUrl + product?.banner}
              alt=""
              style={{ height: "260px" }}
            />
          </div>
        </div>
        <div className="col-md-6">
          <div className="card card-bg p-2">
            <img
              src={imageCdnUrl + product?.product_image}
              alt="Pineapple"
              className="img-fluid w-100"
              style={{ height: "260px" }}
            />
          </div>
        </div>
      </div>
      {/* <div style={{ width: "800px" }}></div> */}
      <div className="row mt-3">
        <div className="col-md-6 mb-5">
          <div className="card card-bg shadow">
            <div className="card-body">
              <h3 className="text-light fw-border mb-3">
                <i>{product?.title}</i>
              </h3>
              <p className="text-light">
                <Markup content={product?.details} />
              </p>
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="registration-body  card-bg m-0 pt-3">
            <div className="row mb-5 m-2">
              <div className="col-md-6 m-0 ">
                <div className="d-flex registration-btn p-2">
                  <div className="mx-3 mt-2">
                    <span className="text-light">
                      <img src={calendar} alt="" className="PriceTage" />
                    </span>
                  </div>
                  <div className=" mx-1">
                    <span className=" text-warning fw-bold">
                      <p className="text-warning fw-bold">
                        <h6>Last Date</h6>
                        {moment(product?.bid_to).format("LL")}
                      </p>
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-md-6 m-0 ">
                <div className="d-flex registration-btn p-2">
                  <div className="mx-3 mt-2">
                    <span className="text-light">
                      <img src={Clock} alt="" className="PriceTage" />
                    </span>
                  </div>
                  <div className=" mx-1">
                    <span className=" text-warning fw-bold">
                      <p className="text-warning fw-bold">
                        <h6>Time</h6>

                        {moment(product?.bid_to).format("LL")}
                      </p>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="col-md-6">
          <div className=" d-flex mt-5 mb-5 cricket-jersey">
            <div className="d-flex p-4 registration-btn">
              <div className="mt-2  mx-3 ">
                <span className="text-light">
                  
                  <img src={calendar} alt="" className="PriceTage" />
                </span>
              </div>
              <div className=" mx-1">
                <span className="text-light">Last Date</span>
                <br></br>
                <span className="text-warning  BtnTextNMP Usd fw-bold">
                  {moment(product?.bid_to).format("LL")}
                </span>
              </div>
            </div>

            <div className=" d-flex p-4 registration-btn ">
              <div className=" mt-2 mx-3">
                <span className="text-light">
                  
                  <img src={Clock} alt="" className="PriceTage" />
                </span>
              </div>
              <div className=" mx-1 ">
                <span className="text-light">Time</span>
                <br></br>
                <span className="text-warning  BtnTextNMP Usd fw-bold">
                  {moment(product?.bid_to).format("HH:mm a")}
                </span>
              </div>
            </div>
          </div>
        </div> */}

        {/* <div className="col-md-4 "></div> */}
      </div>

      <div className="bg-dark table-style p-3">
        <h6 className="">
          <i className="fa-solid fa-box-archive text-warning"></i>
          <span className="text-light mx-3">Upfront Payment</span>
        </h6>

        <table className="table table-borderless table-dark">
          <thead className="thead-dark">
            <tr>
              <th scope="col">User</th>
              <th scope="col">Name</th>
              <th scope="col">Amount</th>
              <th scope="col">Last Payment Time</th>
              <th scope="col">Status</th>
              <th scope="col">Auction</th>
            </tr>
          </thead>
          <tbody>
            {topBidder.map((topper) => (
              <tr>
                <th scope="row">
                  <img
                    className="img-fluid profile-user-biddings"
                    src={imageCdnUrl+topper.user?.image}
                    alt="noimage"
                  />
                </th>
                <td>
                  {topper.user?.first_name} {topper.user?.last_name}
                </td>
                <td>{topper.amount}</td>
                <td>
                  {new Date(topper?.payment_last_date).getTime() >
                  new Date().getTime() ? (
                    <Badge bg="success">
                      <i className="fa-solid fa-clock text-white"></i>
                      {moment(topper?.payment_last_date).format("LL") +
                        " " +
                        moment(topper?.payment_last_date).format("HH:mm a")}
                    </Badge>
                  ) : (
                    <Badge bg="danger">Date Expired</Badge>
                  )}
                </td>
                <td>
                  {topper.applied_status === 1 ? (
                    <Badge bg="success">Applied</Badge>
                  ) : topper.applied_status === 2 ? (
                    <Badge bg="danger">Rejected</Badge>
                  ) : (
                    <Badge bg="primary">Invited</Badge>
                  )}
                </td>
                <td>
                  <div>
                    <button
                      onClick={() => openModal(topper?.id)}
                      className="btn btn-warning mx-1 py-0 px-1"
                      disabled={topper?.payment_status == 1 ? false : true}
                    >
                      <small>Checkout</small>
                    </button>
                    <button
                      className="btn btn-danger m-0 py-0 px-1"
                      disabled={
                        new Date(topper?.payment_last_date).getTime() >
                        new Date().getTime()
                          ? true
                          : false
                      }
                      onClick={() => makeConfirm(topper?.user?.id)}
                    >
                      <small>Reject</small>
                    </button>
                  </div>
                </td>
                <AuctionDoneModal
                  checkoutId={topperId}
                  show={modalShow}
                  onHide={() => setModalShow(false)}
                />
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LiveBiddingsCheckout;
